import {AxiosInstance, AxiosResponse} from 'axios';

export interface IVacationsApi {
    getMany<T>(dateFrom: string, dateTo: string, employees: Array<number>, states: Array<number>): Promise<AxiosResponse<T>>;
    get<T>(id: number): Promise<AxiosResponse<T>>;
    create<T>(body: T): Promise<AxiosResponse<T>>;
    update<T>(id: number, body: T): Promise<AxiosResponse<T>>;
    cancel<T>(id: number): Promise<AxiosResponse<T>>;
    decline<T>(id: number): Promise<AxiosResponse<T>>;
    approve<T>(id: number, force: boolean): Promise<AxiosResponse<T>>;
}

export default class VacationsApi implements IVacationsApi {
    private readonly _axiosInstance: AxiosInstance;
    private readonly _controller: string = 'vacations';
    private readonly _headers = { headers: { 'Content-Type': 'application/json' } };

    constructor(axiosInstance: AxiosInstance) {
        this._axiosInstance = axiosInstance;
    }

    async getMany<T>(dateFrom: string, dateTo: string, employees: number[], states: Array<number>): Promise<AxiosResponse<T>> {
        const employeesSearch = employees.map((x) => `&employees=${x}`).join('');
        const statesSearch = states.map((x) => `&states=${x}`).join('');
        return await this._axiosInstance.get<T>(`${this._controller}?from=${dateFrom}&to=${dateTo}${employeesSearch}${statesSearch}`);
    }
    async get<T>(id: number): Promise<AxiosResponse<T>> {
        return await this._axiosInstance.get<T>(`${this._controller}/${id}`);
    }
    async create<T>(body: T): Promise<AxiosResponse<T>> {
        return await this._axiosInstance.post<T>(`${this._controller}`, JSON.stringify(body), this._headers);
    }
    async update<T>(id: number, body: T): Promise<AxiosResponse<T>> {
        return await this._axiosInstance.put<T>(`${this._controller}/${id}`, JSON.stringify(body), this._headers);
    }
    async cancel<T>(id: number): Promise<AxiosResponse<T>> {
        return await this._axiosInstance.put<T>(`${this._controller}/${id}/cancel`, undefined, this._headers);
    }
    async decline<T>(id: number): Promise<AxiosResponse<T>> {
        return await this._axiosInstance.put<T>(`${this._controller}/${id}/decline`, undefined, this._headers);
    }
    async approve<T>(id: number, force: boolean): Promise<AxiosResponse<T>> {
        return await this._axiosInstance.put<T>(`${this._controller}/${id}/approve`, JSON.stringify(force), this._headers);
    }
}
